module.exports = __webpack_public_path__ + "img/grade5.e12a19b4.jpg";